// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__1EnNa","footer":"ReportModalFilter_footer__2qypt"};